<template>
  <div>
    <service-screen-layout :parts="parts">
      <template v-slot:service>
        <div class="row">
          <div class="col-md-9">
            <div class="row">
              <div class="form-group col-md-6">
                  <label>Description</label>
                  <div class="input-group">
                      <input type="text" class="form-control" v-model="saleDefinition.definition.customer.customerName" >
                  </div>
              </div>
          </div>
            <div class="row">
                <div class="form-group col-md-3">
                  <label>Number of Seats</label>
                  <div class="input-group">
                      <input type="text" class="form-control" v-model="saleDefinition.definition.details.noSeats" disabled>
                  </div>
                </div>
                <div class="form-group col-md-3">
                    <label>Setup Fee</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                R
                            </div>
                        </div>
                        <input type="text" class="form-control" v-model="saleDefinition.definition.details.customSetupFee" disabled>
                    </div>
                </div>
            </div>
            <div class="row row-spacing">
              <div class="col-md-12">
                <div class="form-group">
                  <button
                    class="btn btn-success"
                    @click="saveSale()"
                    type="button"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:regrade>
        <div class="row row-spacing">
          <div class="col-md-2">
            <h3>Regrade</h3>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-5">
                <label>Package</label>
                <div class="input-group">
                  <select class="form-control" v-model="packageSelected" :disabled="hasPending()">
                    <option
                      v-for="packy in availablePackages"
                      :key="packy.rocketseedPackageNumber"
                      :value="packy.rocketseedPackageNumber"
                    >
                      {{ packy.description }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                  <label>Number of Seats</label>
                  <input type="number" class="form-control" v-model="noSeatsSelected" min="1"/></input>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-success" type="button" @click="immediateChangePackage()" :disabled="hasPending() || noSeatsSelected < 1">Immediate Regrade</button>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-success" type="button" @click="scheduleChangePackage()" :disabled="hasPending() || noSeatsSelected < 1">Schedule Regrade</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-spacing">
          <div class="col-md-12">
            <div class="table-bordered table-responsive">
              <table class="table">
                <thead>
                  <tr class="dark-row">
                    <th>Regrade To</th>
                    <th>Description</th>
                    <th>Seats</th>
                    <th>Created</th>
                    <th>Status</th>
                    <th>Scheduled</th>
                  </tr>
                </thead>
                <tbody v-if="packageChanges?.length > 0">
                  <tr v-for="packageChange in packageChanges" :key="packageChange.rocketseedChangeInstructionNumber">
                    <td>{{ packageChange.rocketseedPackageNumber }} </td>  
                    <td>{{ packageChange.packageChange.description }}</td>
                    <td>{{ packageChange.newNoSeats }}</td>
                    <td>{{ packageChange.created }}</td>
                    <td>{{ packageChange.status }}</td>
                    <td>{{ packageChange.billingPeriod }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8">No Regrades requested</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </service-screen-layout>
  </div>
</template>

<script>
import ServiceScreenLayout from "@/layouts/ServiceScreenLayout";
import SaleFunctions from "@/pages/Services/SaleFunctions";
import DateInput from "@/components/GeneralComponents/InputControls/DateInput";
import Modal from "@/components/GeneralComponents/Modal";

export default {
  extends: SaleFunctions,
  components: {
    ServiceScreenLayout,
    DateInput,
    Modal
  },
  data() {
    return {
      parts: [
        {
          name: "service",
          icon: "fa fa-info-circle",
          displayName: "Service",
          permissions: ["*"],
        },
        {
          name: "regrade",
          icon: "fa fa-arrows-v",
          displayName: "Regrade",
          permissions: ["*"],
        },
      ],
      saleDefinition: {
        definition: {
          customer: {
            
          },
          details: {
            noSeats: 0,
          }
        },
      },
      period: this.getCurrentPeriod(),

      packageSelected: null,
      noSeatsSelected: 0,
      availablePackages: [],
      packageChanges: [],
      packages: []
    };
  },
  mounted() {
    this.loadSaleDefinition();
  },
  computed: {
  },
  methods: {
    loadSaleDefinition() {
      const saleNumber = this.$route.params.saleNumber;
      this.getSaleDefinition(saleNumber).then(
        (response) => {
          this.saleDefinition = response.data;

          this.availablePackages = response.data.selectableOptions.rocketPackage
          this.packageChanges = response.data.definition.customer.rocketseedChangeInstructions
          this.noSeatsSelected = response.data.definition.details.noSeats;
          this.getPackages();
        },
        (error) => {
          this.showError("Could not load Sale Definition", error);
          console.error(error);
        }
      );
    },
    getPackages() {
      this.$http.get(this.$config.aimsAPI + "pricing/packages/product/" + this.saleDefinition.product.productNumber + "/RocketseedPackage")
        .then(
          (response) => {
            this.packages = response.data;
          },
          (error) => {
            this.showError("Error fetching Rocketseed Packages", error);
            console.error(error);
          }
        );
    },
    saveSale() {
      this.$http.put(this.$config.aimsAPI + "sales/definition/" +
          this.saleDefinition.sale.saleNumber + "/update", this.saleDefinition
        ).then(() => {
            this.showSuccess("Save Success");
            this.loadSaleDefinition();
          },(error) => {
            console.error(error);
            this.showError("Error Saving SaleDefinition", error);
          }
        );
    },

    scheduleChangePackage: function () {
      if (this.packageSelected) {
        const packy = this.packages.find(
          (packy) => packy.rocketseedPackageNumber === this.packageSelected
        );
        const priceInclVAT = "Incl VAT " + this.getPrice(packy.prices, this.period, true) + " x " + this.noSeatsSelected;

        this.$swal({
          title: "Regrade effective 1st of next month?",
          text: priceInclVAT,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Regrade",
        }).then((result) => {
          if (result.value) {
            this.packageChange(packy, false);
          }
        });
      } else {
        this.showWarningAlert("Please select a Package to regrade to")
      }
    },
    immediateChangePackage: function () {
      if (this.packageSelected) {
        const packy = this.packages.find(
          (packy) => packy.rocketseedPackageNumber === this.packageSelected
        );
        const priceInclVAT = "Incl VAT " + this.getPrice(packy.prices, this.period, true) + " x " + this.noSeatsSelected;

        this.$swal({
          title: "Immediate Regrades will have additional billing for this month?",
          text: priceInclVAT,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Regrade",
        }).then((result) => {
          if (result.value) {
            this.packageChange(packy, true);
          }
        });
      } else {
        this.showWarningAlert("Please select a Package to regrade to")
      }
    },
    hasPending() {
      if (this.packageChanges != null) {
        for (const item of this.packageChanges) {
          if (item.status.toLowerCase().includes("pending".toLocaleLowerCase())) {
            return true;
          }         
        }
      }
      return false;   
    },

    packageChange: function (packageChange, immediate) {
      let changePackageInstruction = this.deepCopyObject(this.saleDefinition.supportingObjs.rocketseedChangeInstructions);
      changePackageInstruction.rocketseedCustomerNumber =  this.saleDefinition.definition.customer.rocketseedCustomerNumber;
      changePackageInstruction.rocketseedPackageNumber = packageChange.rocketseedPackageNumber;
      changePackageInstruction.newNoSeats = this.noSeatsSelected;
      if (immediate) {
        changePackageInstruction.billingPeriod = this.getCurrentPeriod();
      } else {
        changePackageInstruction.billingPeriod = this.increaseBillingPeriod(this.getCurrentPeriod());
      }
      this.createObjPart(changePackageInstruction, true).then(
        (response) => {
          this.showSuccess("Regrade successfully submitted");
          this.loadSaleDefinition();
        },
        (error) => {
          console.error(error);
          this.showError("Error with Regrade Instruction", error);
        }
      );
    },
    getPrice(data, period, vat) {
      if (data) {
        if (data.length > 0) {
          let price = data.filter((price) => period >= price.validFrom);
          price.forEach((newPrice) => {
            if (newPrice.validUntil != 0) {
              price = price.filter((price) => period <= price.validUntil);
            } else {
              price = newPrice;
            }
          });
          if (Array.isArray(price)) {
            if (price.length > 0) {
              if (vat) {
                return this.timesVAT(
                  parseFloat(price[0].priceExclVat)
                );
              } else {
                return this.currencyFormat(
                  parseFloat(price[0].priceExclVat)
                );
              }
            } else {
              return "R " + 0;
            }
          } else {
            if (vat) {
              return this.timesVAT(
                parseFloat(price.priceExclVat)
              );
            } else {
              return this.currencyFormat(
                parseFloat(price.priceExclVat)
              );
            }
          }
        } else {
          return "R " + 0;
        }
      } else {
        return 0;
      }
    },
  },
};
</script>